import {axiosGet} from "../../../Helpers/AxiosHelper";

const state = {
    ageList: [],
};
const getters = {
    getAge: state => state.ageList

};

const mutations = {
    AGE_INFO(state, data) {
        state.ageList = data
    }
};

const actions = {
    getAge({commit}) {
        axiosGet(`crm/age/status`).then((response) => {
            commit('AGE_INFO', response.data)
        }).catch((error) => console.log(error));
    }
};


export default {
    state,
    getters,
    mutations,
    actions
}
